import { FC, ReactElement } from 'react';

import { Box, BoxProps, rem } from '@bonusly/design-system';

interface KeyProps extends BoxProps {
	icon?: ReactElement;
}

export const Key: FC<KeyProps> = ({ children, icon, ...rest }) => (
	<Box
		as="kbd"
		backgroundColor="gray.25"
		borderColor="gray.100"
		borderRadius={rem(2.2)}
		borderWidth={rem(1)}
		borderBottomWidth={rem(3)}
		px={rem(2)}
		fontSize="0.7em"
		lineHeight="normal"
		{...(!icon &&
			typeof children === 'string' && {
				px: 1.5,
			})}
		{...rest}
	>
		{icon || children}
	</Box>
);
